// extracted by mini-css-extract-plugin
module.exports = {"plan-update-warning":"plan-update-warning__13X46"};